import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../../../../globals";
import { ProductsServices } from "../../../../services";
import { ConfigurationServices } from '../../../../../configuration/services';
import { TranslateService } from '@ngx-translate/core';
import { AddonsTriggerVersionProPage } from '../../../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';

/**
 * Generated class for the ProductPartialWfoodcostIndicatorsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-product-partial-wfoodcost-indicators',
    templateUrl: 'product-partial-wfoodcost-indicators.html',
})
export class ProductPartialWfoodcostIndicatorsPage {

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals,
        public productsServices: ProductsServices,
        public configurationServices: ConfigurationServices,
        public translate: TranslateService,) {
    }

    checkState(allergen_uid) {
        var index = this.productsServices.products_allergens_tmp.indexOf(allergen_uid, 0);
        if (index > -1) {
            return true
        } else {
            return false
        }
    }

    insert(allergen_uid) {
        if (this.globals.checkLimitsByLicense('stock', 'indicators')) {
            this.productsServices.products_allergens_tmp.push(allergen_uid);
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

    delete(allergen_uid) {
        if (this.globals.checkLimitsByLicense('stock', 'indicators')) {
            var index = this.productsServices.products_allergens_tmp.indexOf(allergen_uid, 0);
            if (index > -1) {
                this.productsServices.products_allergens_tmp.splice(index, 1);
            }
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

}



// WEBPACK FOOTER //
// ./src/pages/products/product-create/product-create-without-foodcost/product-create-wfoodcost-allergens/product-partial-wfoodcost-indicators/product-partial-wfoodcost-indicators.ts